export const injectAdsInFeed = ads => {
  return {
    type: "INJECT_ADS_IN_FEED",
    ads,
  };
};

export const loadNextAd = ads => {
  return {
    type: "LOAD_NEXT_AD_REQUEST",
    ads,
  };
};
export const addNewAd = adData => {
  return {
    type: "ADD_NEW_AD",
    adData,
  };
};



// WEBPACK FOOTER //
// ./src/actions/adActions.js